const setSubNavVisible = (subNavElementId) => {
  const subnav = document.getElementById(subNavElementId);
  Object.assign(subnav.style, { display: 'block', zIndex: -1 });
};

export default setSubNavVisible;
